import React, { useState } from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Work from "./components/Work";
import About from "./components/About";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ProjectModal from "./components/ProjectModal";

function App() {
  const [activeProject, setActiveProject] = useState(null);

  return (
    <div className="App" id="top">
      <Navbar />
      <main>
        <Hero />
        <Work onOpen={setActiveProject} />
        <About />
        <Services />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <ProjectModal
        project={activeProject}
        onClose={() => setActiveProject(null)}
      />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
